import { create } from "zustand";

const initialState = {
  initialViewDetail: null,
  modifiedViewDetail: null,
  loading: false,
  error: null,
  openModal: false,
  enableSaveBtn: false,
  enableCancelBtn: false,
  cache: {},
};

export const useViewDetailStore = create((set) => ({
  ...initialState,
  setInitialViewDetail: (viewDetail) => set({ initialViewDetail: viewDetail }),
  setModifiedViewDetail: (viewDetail) => set({ modifiedViewDetail: viewDetail }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setOpenModal: (openModal) => set({ openModal }),
  setEnableSaveBtn: (enableSaveBtn) => set({ enableSaveBtn }),
  setEnableCancelBtn: (enableCancelBtn) => set({ enableCancelBtn }),
  setCache: (key, value) => set((state) => ({ cache: { ...state.cache, [key]: value } })),
  reset: () => set(initialState),
}));
